module.exports = __webpack_public_path__ + "img/Discord-hover.8ced5a3f.svg";